export default __webpack_public_path__ + "static/media/Q13_0_resized.4e7cac09.jpg";